<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Términos y condiciones</h1>

      <p>
        <i>Última actualización: 2 de abril de 2025</i>
      </p>

      <br />
      <p>
        Bienvenido a FEROS DINAFLEX. Al acceder y utilizar nuestro sitio web https://ferosdinaflex.online y nuestra plataforma en la nube, usted acepta quedar vinculado por los siguientes Términos y Condiciones. Si no está de acuerdo con estos términos, le recomendamos no utilizar nuestros servicios.
      </p>

      <br />
      <h6>1. Identidad del Titular</h6>
      <p>
        FEROS DINAFLEX es una empresa dedicada a la venta de productos saludables mediante un esquema de distribución tipo multinivel. Ofrecemos una plataforma digital para clientes, distribuidores y promotores, facilitando la compra de productos y el crecimiento dentro del modelo de negocios.
      </p>

      <br />
      <h6>2. Acceso y Registro</h6>
      <p>
        Para utilizar los servicios de FEROS DINAFLEX, es necesario registrarse y crear una cuenta de usuario. Usted declara que toda la información proporcionada es verídica, actual y completa. FEROS DINAFLEX se reserva el derecho de suspender o cancelar cuentas que incumplan con este requisito.
      </p>

      <br />
      <h6>3. Uso de la Plataforma</h6>
      <p>
        Los usuarios se comprometen a utilizar el sitio y sus herramientas de manera lícita y respetuosa. Está prohibido:
      </p>
      <ul>
        <li>
          Utilizar la plataforma para fines fraudulentos, engañosos o contrarios a la ley
        </li>
        <li>
          Realizar prácticas que afecten el funcionamiento del sistema
        </li>
        <li>
          Suplantar la identidad de otro usuario
        </li>
        <li>
          Distribuir contenido ofensivo o no autorizado
        </li>
      </ul>

      <br />
      <h6>4. Esquema Multinivel</h6>
      <p>
        Al registrarse como distribuidor, el usuario acepta formar parte de un esquema de comisiones basado en su volumen de ventas y el de sus referidos. Las condiciones del plan de compensación están disponibles dentro de la plataforma y pueden ser modificadas con previo aviso.
      </p>

      <br />
      <p>
        FEROS DINAFLEX no garantiza ingresos mínimos, y los resultados dependen del esfuerzo individual de cada distribuidor.
      </p>

      <br />
      <h6>5. Compras y Pagos</h6>
      <p>
        Las compras realizadas a través de nuestra tienda están sujetas a disponibilidad y confirmación de pago. Los precios se muestran en moneda local e incluyen impuestos, salvo que se indique lo contrario. Los métodos de pago aceptados son aquellos visibles en el checkout del sitio.
      </p>

      <br />
      <h6>6. Envíos y Entregas</h6>
      <p>
        Los tiempos de entrega y condiciones de envío pueden variar según la ubicación del comprador. FEROS DINAFLEX no se hace responsable por retrasos imputables a terceros (paqueterías u operadores logísticos).
      </p>

      <br />
      <h6>7. Devoluciones y Reembolsos</h6>
      <p>
        Solo se aceptarán devoluciones de productos no usados y en su empaque original, dentro de los primeros 7 días naturales posteriores a la entrega. Los gastos de envío no son reembolsables, salvo en casos de producto defectuoso o error de envío.
      </p>

      <br />
      <h6>8. Propiedad Intelectual</h6>
      <p>
        Todo el contenido presente en la plataforma, incluyendo marcas, logotipos, textos, imágenes y código fuente, es propiedad de FEROS DINAFLEX o cuenta con licencia de uso. Queda prohibida su reproducción total o parcial sin autorización expresa.
      </p>

      <br />
      <h6>9. Modificaciones</h6>
      <p>
        FEROS DINAFLEX se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios entrarán en vigor desde su publicación en https://ferosdinaflex.online. El uso continuo del sitio implica su aceptación.
      </p>

      <br />
      <h6>10. Limitación de Responsabilidad</h6>
      <p>
        FEROS DINAFLEX no será responsable por daños directos o indirectos derivados del uso o mal uso de la plataforma, o por interrupciones del servicio por causas técnicas, mantenimiento, o fuerza mayor.
      </p>

      <br />
      <h6>11. Jurisdicción y Legislación Aplicable</h6>
      <p>
        Este acuerdo se rige por las leyes mexicanas. En caso de controversia, ambas partes se someten a la jurisdicción de los tribunales competentes en la Ciudad de México, renunciando a cualquier otro fuero que pudiera corresponderles.
      </p>

      <br />
      <h6>12. Contacto</h6>
      <p>
        Para cualquier duda relacionada con estos Términos y Condiciones, puede escribirnos a:<br />
        <strong>contacto@ferosdinaflex.online</strong>
      </p>

    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
